<template>
  <div class="modal modal-login fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center py-6 px-5">
        <button type="button" class="modal__close d-flex align-items-center justify-content-center" data-dismiss="modal">
          <svg-icon icon="close-remove"></svg-icon>
        </button>

        <form action="#" method="post" @submit.prevent="submitEmail" v-if="step == 1">
          <div class="modal-login__icon">
            <svg-icon icon="logo"></svg-icon>
          </div>

          <div class="modal-login__text pt-4 pb-3">
            Для входа, введите, пожалуйста, ваш e-mail
          </div>

          <div class="form-group pb-4">
            <input class="form-group__input modal-login__input text-center" name="email" type="email" placeholder="Ваш e-mail" required v-model="email">
            <div class="form-group__error" v-if="errors && errors.email">{{errors.email[0]}}</div>
          </div>

          <button class="button-green modal-login__button" :disabled="step1_disabled" type="submit">Получить код</button>

          <div class="modal-login__sub pt-2">
            Нажимая на кнопку «Получить код» вы соглашаетесь с <a :href="route('page.static', {page: 'oferta'})" target="_blank">пользовательским соглашением</a>
          </div>
        </form>

        <form action="#" method="post" @submit.prevent="submitToken" v-if="step == 2">
          <div class="modal-login__icon">
            <svg-icon icon="logo"></svg-icon>
          </div>

          <div class="modal-login__text pt-4 pb-3">
            Код для входа отправлен на указанный e-mail. Введите его или перейдите по ссылке из письма
          </div>

          <div class="form-group pb-4">
            <input class="form-group__input modal-login__input text-center" name="token" type="text" placeholder="Код для входа" required v-model="token">
            <div class="form-group__error" v-if="errors && errors.token">{{errors.token[0]}}</div>
          </div>

          <button class="button-green modal-login__button" :disabled="step2_disabled" type="submit">Войти</button>

          <div class="modal-login__sub pt-2">
            Не пришел код на почту? <a href="#" @click.prevent="step = 1">Попробуйте ввести email еще раз</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Modal from '../index'
  import Api from '@MAIN/app/api'

  $(() => {
    $('.js-login-button').click(function(e){
      if ($(this).data('auth')) {
        return true
      }
      e.preventDefault()

      Modal.setType('login')
    })

    if (document.location.hash === 'force-auth') {
      Modal.setType('login')
    }
  })

  export default {
    data() {
      return {
        step: 1,
        step1_disabled : false,
        step2_disabled : false,

        encrypted_email: null,
        email: null,
        token: null,

        errors : {},
        custom_callback : null
      }
    },
    methods: {
      cleanUp() {
        this.custom_callback = null
        this.encrypted_email = null
      },
      setCustomCallback(cb) {
        this.custom_callback = cb
      },
      submitEmail() {
        this.step1_disabled = true
        Api.auth.login(this.email)
          .then((response) => {
            if (response.success) {
              this.encrypted_email = response.email
              this.step = 2
            }
          })
          .catch(response => {
            switch (response.status) {
              case 429:
                const retry_after = response.getResponseHeader('retry-after')
                this.errors = {email : [`Повторно отправить запрос вы сможете через ${retry_after} ${this.plural(retry_after, ['секунду', 'секунды', 'секунд']) }`]}
                break;
              case 422:
              default:
                this.errors = response.responseJSON
            }
          })
          .finally(() => {
            this.step1_disabled = false
          })
      },

      submitToken() {
        this.step2_disabled = true
        Api.auth.token(this.token, this.encrypted_email)
          .then((response) => {
            if (response.success) {
              if (this.custom_callback) {
                this.custom_callback(response)
              } else {
                document.location = '/cp'
              }
            } else {
              this.errors = {token : [`Код не подходит`]}
            }
          })
          .catch(response => {
            switch (response.status) {
              case 429:
                const retry_after = response.getResponseHeader('retry-after')
                this.errors = {token : [`Повторно отправить запрос вы сможете через ${retry_after} ${this.plural(retry_after, ['секунду', 'секунды', 'секунд']) }`]}
                break;
              case 422:
              default:
                this.errors = response.responseJSON
            }
          })
          .finally(() => {
            this.step2_disabled = false
          })
      }
    }
  }
</script>
